






























































import { Component, Prop, Vue } from "vue-property-decorator";

import { ModalAction } from "@/components/modalActionTypes";

@Component({
  components: {},
})
export default class VModal extends Vue {
  @Prop({ default: "" }) readonly size?: string;
  @Prop({ default: true }) readonly canClose?: boolean;
  @Prop({ default: false }) readonly overflow?: boolean;
  @Prop({ default: 27 }) readonly closeKeyCode?: number;
  @Prop({ default: "" }) readonly title!: string;
  @Prop({ default: () => [] }) readonly actions!: ModalAction[];

  visible = false;

  mounted() {
    document.addEventListener("keydown", this.onKeyPress);
  }

  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeyPress);
  }

  show() {
    this.visible = true;
    this.$emit("shown");
  }

  hide() {
    if (!this.visible) return;
    this.visible = false;
    this.$emit("hidden");
  }

  hasHeader() {
    return this.$slots.header != null || this.title !== "";
  }

  hasFooter() {
    return this.$slots.footer != null || this.actions.length > 0;
  }

  closeModal() {
    if (this.canClose && this.visible) {
      this.hide();
    }
  }

  onKeyPress(e: KeyboardEvent) {
    if (e.keyCode !== this.closeKeyCode) {
      return;
    }
    this.closeModal();
  }
}
